(() => {
  'use strict';

  const PDFJS_CDN    = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
  const PDFJS_WORKER = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

  const modal          = document.getElementById('catalog-modal');
  const modalContainer = document.getElementById('catalog-modal-container');
  const closeBtn       = document.getElementById('catalog-close-btn');
  const pagesContainer = document.getElementById('catalog-pages-container');
  const downloadBtn    = document.querySelector('.catalog-modal__download');

  if (!modal || !modalContainer || !pagesContainer) return;

  let pdfDoc      = null;
  let pdfJsLoaded = false;
  let currentUrl  = null;

  /* ── Public API ─────────────────────────────────────────────────── */

  window.CatalogViewer = { open: openCatalog };

  /* ── Modal open / close ─────────────────────────────────────────── */

  async function openCatalog(url) {
    if (!url) return;

    modal.classList.remove('catalog-modal--hidden');
    document.body.style.overflow = 'hidden';

    if (downloadBtn) downloadBtn.href = url;

    if (!pdfJsLoaded) {
      await loadScript(PDFJS_CDN);
      pdfJsLoaded = true;
    }

    if (url !== currentUrl) {
      currentUrl = url;
      pagesContainer.innerHTML = '';
      pdfDoc = null;
      await loadAndRender(url);
    }
  }

  const closeModal = () => {
    modal.classList.add('catalog-modal--hidden');
    document.body.style.overflow = '';
  };

  /* ── PDF loading & rendering ────────────────────────────────────── */

  const loadAndRender = async (url) => {
    pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER;

    try {
      pdfDoc = await pdfjsLib.getDocument(url).promise;
      await renderAllPages();
    } catch (err) {
      console.error('[CatalogViewer] Failed to load PDF:', err);
    }
  };

  const renderAllPages = async () => {
    pagesContainer.innerHTML = '';

    for (let i = 1; i <= pdfDoc.numPages; i++) {
      await renderPage(i);
    }
  };

  const renderPage = async (pageNum) => {
    const page     = await pdfDoc.getPage(pageNum);
    const scale    = getScale(page);
    const viewport = page.getViewport({ scale });

    const canvas       = document.createElement('canvas');
    canvas.className   = 'catalog-page-canvas';
    canvas.height      = viewport.height;
    canvas.width       = viewport.width;
    pagesContainer.appendChild(canvas);

    await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise;
  };

  const getScale = (page) => {
    const containerWidth = pagesContainer.offsetWidth || window.innerWidth * 0.8 - 48;
    const viewport       = page.getViewport({ scale: 1 });
    return containerWidth / viewport.width;
  };

  /* ── Re-render on resize ────────────────────────────────────────── */

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(async () => {
      if (!pdfDoc) return;
      await renderAllPages();
    }, 300);
  });

  /* ── Event listeners ────────────────────────────────────────────── */

  closeBtn?.addEventListener('click', closeModal);

  downloadBtn?.addEventListener('click', async (e) => {
    e.preventDefault();
    const url      = downloadBtn.getAttribute('href');
    if (!url || url === '#') return;
    const filename = url.split('/').pop().split('?')[0] || 'catalogue.pdf';

    try {
      const res       = await fetch(url);
      const blob      = await res.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a         = Object.assign(document.createElement('a'), { href: objectUrl, download: filename });
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
    } catch {
      window.open(url, '_blank');
    }
  });

  modal.addEventListener('click', (e) => {
    if (!modalContainer.contains(e.target)) closeModal();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.classList.contains('catalog-modal--hidden')) closeModal();
  });

  /* ── Helpers ────────────────────────────────────────────────────── */

  const loadScript = (src) =>
    new Promise((resolve, reject) => {
      const s   = document.createElement('script');
      s.src     = src;
      s.onload  = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
})();
